import { ProposalLayout } from "generated/graphql";
import { z } from "zod";
import { draftColors } from "./draftDesignTokens";

export const confirmProposalModalSchema = z
  .object({
    proposalId: z.string().min(1),
    layout: z.nativeEnum(ProposalLayout),
    sendToMultipleCompanies: z.boolean().default(false),
    emails: z.array(z.union([z.literal(""), z.string().email("Please enter a valid email address")])),
    packageRecipients: z
      .array(
        z.object({
          companyId: z.string().optional().or(z.literal("")),
          contactId: z.string().optional().or(z.literal("")),
        })
      )
      .default([]),
    removeUnitPriceAndQuantity: z.boolean().optional(),
    removeIndividualLineItemPricing: z.boolean().optional(),
    attachments: z.array(z.string()).optional(),
    contentSettingIds: z.array(z.string()).optional(),
    emailSubjectOverride: z.string().optional().or(z.null()),
    emailBodyOverride: z.string().min(1, "Email body is required"),
    clientEmailOverride: z.string().optional().or(z.null()),
    acceptanceOverride: z.string().optional().or(z.null()),
  })
  .superRefine((data, ctx) => {
    if (!data.sendToMultipleCompanies) {
      return;
    }

    const completedRecipients = data.packageRecipients.filter((recipient) => {
      return recipient.companyId && recipient.contactId;
    });

    if (completedRecipients.length < 2) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Select at least two GC company/contact pairs",
        path: ["packageRecipients"],
      });
    }
  });

export type ConfirmProposalModalFormValues = z.infer<typeof confirmProposalModalSchema>;

export const confirmProposalDropdownInnerSx = {
  "& .MuiFormControl-root": { marginTop: "0 !important" },
  "& .MuiInput-root, & .MuiOutlinedInput-root": {
    fontSize: "12px",
    fontWeight: 400,
    color: draftColors.textPrimary,
    padding: "4px 8px !important",
    minHeight: "unset",
    border: `1px solid ${draftColors.border}`,
    borderRadius: "8px",
    "&::before, &::after": { display: "none" },
    "& > div": { marginTop: "0 !important" },
  },
  "& .MuiInputBase-input": { padding: "0 !important", fontSize: "12px" },
  "& .MuiSelect-select": { padding: "0 24px 0 0 !important", fontSize: "12px" },
  "& .MuiFormLabel-root": { display: "none" },
  "& .MuiChip-root": {
    height: "22px",
    fontSize: "11px",
    backgroundColor: `${draftColors.blue} !important`,
    color: "#fff !important",
    "& .MuiChip-deleteIcon": { color: "rgba(255,255,255,0.7) !important" },
  },
} as const;
